module.exports = __webpack_public_path__ + "static/img/parents.fe7f4520.png";